export const AddressTypeDescriptions = new Map([
    ['BILLING_ADDRESS', $localize`Invoice address`],
    ['MAIN_ADDRESS', $localize`Main address`]
]);
